/* AccordianBox.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _isBoolean from "lodash/isBoolean";
const _excluded = ["as", "style"],
  _excluded2 = ["as", "style"];
import { forwardRef } from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
const _5 = "._18u0pxbi{margin-left:var(--ds-space-200,1pc)}";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import Button from '@atlaskit/button';
import EditorRemoveIcon from '@atlaskit/icon/glyph/editor/remove';
import ChevronDownIcon from '@atlaskit/icon/glyph/hipchat/chevron-down';
import ChevronUpIcon from '@atlaskit/icon/glyph/hipchat/chevron-up';
import { draggable, dropTargetForElements } from '@atlaskit/pragmatic-drag-and-drop/element/adapter';
import { Box, Flex, xcss } from '@atlaskit/primitives';
import invariant from 'invariant';
import { useEffect, useRef, useState } from 'react';
import { ACCORDIAN_BOX, ACCORDIAN_BOX_CLOSE_ICON, ACCORDIAN_BOX_DELETE_ICON, ACCORDIAN_BOX_OPEN_ICON } from '../../constants/testIds';
import DragHandlerIcon from './icons/drag-handler-icon.svg';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const _4 = "._80omtlke{cursor:pointer}";
const _3 = "._4cvr1h6o{align-items:center}";
const _2 = "._1bah1yb4{justify-content:space-between}";
const _ = "._1e0c1txw{display:flex}";
const boxStyles = xcss({
  border: "1px solid ".concat("var(--ds-border, #091E4224)"),
  paddingTop: 'space.150',
  paddingBottom: 'space.150',
  paddingLeft: 'space.300',
  paddingRight: 'space.300',
  borderRadius: 'radius.small'
});
const draggingStyles = xcss({
  opacity: '0.4'
});
const dropStateStyles = xcss({
  border: "2px solid ".concat("var(--ds-text-selected, #0C66E4)")
});
const AccordianHead = forwardRef((_ref, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref,
    __cmplp = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_1e0c1txw _1bah1yb4 _4cvr1h6o _80omtlke", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  AccordianHead.displayName = 'AccordianHead';
}
const titleStyles = xcss({
  fontSize: '16px',
  fontWeight: '600',
  width: '100%'
});
const TitleContent = forwardRef((_ref2, __cmplr) => {
  let {
      as: C = "div",
      style: __cmpls
    } = _ref2,
    __cmplp = _objectWithoutProperties(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_5]
    }), /*#__PURE__*/_jsx(C, _objectSpread(_objectSpread({}, __cmplp), {}, {
      style: __cmpls,
      ref: __cmplr,
      className: ax(["_18u0pxbi", __cmplp.className])
    }))]
  });
});
if (process.env.NODE_ENV !== 'production') {
  TitleContent.displayName = 'TitleContent';
}
const contentStyles = xcss({
  paddingTop: 'space.200'
});
const hideContent = xcss({
  display: 'none'
});
const AccordianBox = props => {
  const defaultState = true;
  const [isOpen, setIsOpen] = useState(_isBoolean(props.isOpen) ? props.isOpen : defaultState);
  const ref = useRef(null);
  const boxRef = useRef(null);
  const [dragging, setDragging] = useState(false);
  const [dropState, setDropState] = useState(false);
  const onDelete = event => {
    event.stopPropagation();
    if (props.onDelete) {
      props.onDelete();
    }
  };
  useEffect(() => {
    if (props.enableDrag) {
      const el = ref.current;
      const boxEl = boxRef.current;
      invariant(el, 'required');
      invariant(boxEl, 'required');
      draggable({
        element: el,
        getInitialData: () => ({
          id: props.id
        }),
        onDragStart: () => setDragging(true),
        onDrop: () => setDragging(false)
      });
      return dropTargetForElements({
        element: boxEl,
        getData: () => ({
          id: props.id
        }),
        onDragEnter: () => {
          setDropState(true);
        },
        onDragLeave: () => setDropState(false),
        onDrop: () => setDropState(false)
      });
    }
  }, [props.id, props.enableDrag]);
  return /*#__PURE__*/_jsxs(Box, {
    xcss: [boxStyles, dragging && draggingStyles, dropState && dropStateStyles],
    testId: ACCORDIAN_BOX,
    ref: boxRef,
    children: [/*#__PURE__*/_jsxs(AccordianHead, {
      onClick: () => setIsOpen(!isOpen),
      children: [/*#__PURE__*/_jsxs(Flex, {
        xcss: titleStyles,
        children: [/*#__PURE__*/_jsx("img", {
          src: DragHandlerIcon,
          alt: "darg-handler-icon",
          ref: ref
        }), /*#__PURE__*/_jsx(TitleContent, {
          children: props.title
        })]
      }), /*#__PURE__*/_jsxs(Flex, {
        alignItems: "center",
        children: [props.onDelete && /*#__PURE__*/_jsx(Button, {
          iconBefore: /*#__PURE__*/_jsx(EditorRemoveIcon, {
            testId: ACCORDIAN_BOX_DELETE_ICON,
            label: "delete-icon"
          }),
          onClick: onDelete,
          appearance: "subtle"
        }), !isOpen && /*#__PURE__*/_jsx(ChevronDownIcon, {
          testId: ACCORDIAN_BOX_OPEN_ICON,
          label: "down-icon"
        }), isOpen && /*#__PURE__*/_jsx(ChevronUpIcon, {
          testId: ACCORDIAN_BOX_CLOSE_ICON,
          label: "up-icon"
        })]
      })]
    }), /*#__PURE__*/_jsx(Box, {
      xcss: [contentStyles, !isOpen && hideContent],
      children: props.children
    })]
  });
};
export default AccordianBox;